// Centralised CMS client. Talks directly to Strapi and returns Strapi v4 shape:
// {data, meta}.
import axios from "axios";
import { getCmsApiBaseUrl } from "@/lib/cmsBase";

const CMS_BASE = getCmsApiBaseUrl();

const cms = axios.create({ baseURL: CMS_BASE, timeout: 15000 });

// --- Blog ---
export async function fetchBlogList({ category, page = 1, pageSize = 50 } = {}) {
  const query = {
    "pagination[page]": page,
    "pagination[pageSize]": pageSize,
    "sort": "publishedAt:desc",
    "publicationState": "live",
    "populate": "*",
  };
  if (category && category.toLowerCase() !== "all") {
    query["filters[category][$eqi]"] = category;
  }
  const { data } = await cms.get("/blog-posts", { params: query });
  return {
    items: (data.data || []).map((d) => ({ id: d.id, ...d.attributes })),
    meta: data.meta || {},
  };
}

export async function fetchBlogBySlug(slug) {
  const { data } = await cms.get("/blog-posts", {
    params: {
      "filters[slug][$eq]": slug,
      "publicationState": "live",
      "populate": "*",
      "pagination[limit]": 1,
    },
  });
  if (!data?.data) return null;
  const entry = Array.isArray(data.data) ? data.data[0] : data.data;
  if (!entry) return null;
  return { id: entry.id, ...entry.attributes };
}

export async function fetchBlogCategories() {
  const { data } = await cms.get("/blog-posts", {
    params: {
      "fields[0]": "category",
      "pagination[pageSize]": 500,
      "publicationState": "live",
    },
  });
  const cats = new Set();
  for (const item of data?.data || []) {
    const category = item?.attributes?.category;
    if (category) cats.add(category);
  }
  return Array.from(cats).sort();
}

// --- Case Studies ---
export async function fetchCaseStudyList({ page = 1, pageSize = 50 } = {}) {
  const { data } = await cms.get("/case-studies", {
    params: {
      "pagination[page]": page,
      "pagination[pageSize]": pageSize,
      "sort": "createdAt:desc",
      "publicationState": "live",
      "populate": "*",
    },
  });
  return {
    items: (data.data || []).map((d) => ({ id: d.id, ...d.attributes })),
    meta: data.meta || {},
  };
}

export async function fetchCaseStudyBySlug(slug) {
  const { data } = await cms.get("/case-studies", {
    params: {
      "filters[slug][$eq]": slug,
      "publicationState": "live",
      "populate": "*",
      "pagination[limit]": 1,
    },
  });
  if (!data?.data) return null;
  const entry = Array.isArray(data.data) ? data.data[0] : data.data;
  if (!entry) return null;
  return { id: entry.id, ...entry.attributes };
}

export default cms;
